module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (221).82dea5c1.jpg";